var FcTimeInputModule = /** @class */ (function () {
    function FcTimeInputModule() {
    }
    return FcTimeInputModule;
}());
export { FcTimeInputModule };
